/**
 * component image key. Gets object type and objectId from the payload
 * @param payload
 * @returns {string}
 */
export function fileComponentKey(payload) {
  return payload.objectType + '_' + payload.objectId;
}

export function extractFileComponentKey(key) {
  const splitted = key.split('_');
  return { objectType: splitted[0], objectId: parseInt(splitted[1]) };
}
